import React from "react"
import { Container } from "reactstrap"

import Breadcrumbs from "../../components/Common/Breadcrumb"
import MetaTag from "components/Common/Meta-tag"
import MatchingListTable from "./DataTables"

function MatchingList() {
  return (
    <>
      <MetaTag title={"All MatchingList"} />

      <div className="page-content">
        <Breadcrumbs title="Dashboard" breadcrumbItem="All MatchingList" />
        <Container fluid>
          <div className="container-fluid">
            <MatchingListTable />
          </div>
        </Container>
      </div>
    </>
  )
}

export default MatchingList
